import { AxiosPromise } from 'axios';
import { IRequestPasswordResetCommand } from './types';
import { instance } from '../../services/api';

export default (data: IRequestPasswordResetCommand): AxiosPromise =>
  instance.post(`api/accounts/${data.userName}/reset`);
